module.exports = __webpack_public_path__ + "img/top_add_point_mo.014bcc07.jpg";